import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  output, signal
} from '@angular/core';
import {actionsWidths, columnsConfig, resultsWidths, statsWidths} from "../../configs/columns.config";
import {
  PlanFactTableDataGroupedByMonths,
  PlatformsName,
  Product,
  ToggleColumnAction,
  UpdateValueParams
} from "../../types/table-data.types";
import {UtilityService} from "../../../../../core/services/utility.service";
import {PlanFactService} from "../../services/plan-fact.service";
import { FactHeaderComponent } from "../fact-header/fact-header.component";
import { GroupedHeaderColumnsComponent } from "../grouped-header-columns/grouped-header-columns.component";
import { FactValueComponent } from "../fact-value/fact-value.component";
import { GroupedValueColumnsComponent } from "../grouped-value-columns/grouped-value-columns.component";
import {
  UpdateInputNumberComponent
} from "../../../../../shared/components/update-input/update-input-number.component";

@Component({
  selector: 'app-plan-fact-platform',
  standalone: true,
  imports: [
    FactHeaderComponent,
    GroupedHeaderColumnsComponent,
    FactValueComponent,
    GroupedValueColumnsComponent,
    UpdateInputNumberComponent
  ],
  templateUrl: './plan-fact-platform.component.html',
  styleUrls: [
    './plan-fact-platform.component.scss',
    '../plan-fact-components-styles.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanFactPlatformComponent implements OnInit {
  product = input.required<Product>();
  selectedYear = input.required<number>();
  monthData = input.required<PlanFactTableDataGroupedByMonths>();
  platform = input.required<PlatformsName>();
  toggleActionsColumn = output<ToggleColumnAction>();

  private utilityService: UtilityService = inject(UtilityService);
  private planFactService: PlanFactService = inject(PlanFactService);

  protected readonly actionsWidths = actionsWidths;
  protected readonly resultsWidths = resultsWidths;
  protected readonly statsWidths = statsWidths;
  protected readonly columnsConfig = columnsConfig;

  public propertyIntegrationsPlan = signal<string>('');
  public propertyPlan = signal<string>('');
  public openName = signal<string>('');

  public ngOnInit(): void {
    this.propertyPlan.set(`${this.platform().type}Plan`);
    this.propertyIntegrationsPlan.set(`${this.platform().type}IntegrationsPlan`);
    this.openName.set(`is${this.platform().title}Open`);
  }

  public handleActionsColumn(toggleColumnAction: ToggleColumnAction): void {
    this.toggleActionsColumn.emit(toggleColumnAction);
  }

  public formatNumberValueToRubles(value: number | string): string {
    return this.utilityService.formatBudgetValue({value: Number(value)});
  }

  public formatNumberValue(value: number | string, fractional: number = 0): string {
    return this.utilityService.formatNumberForDisplay({
      value: +value,
      fractional: { value: fractional },
      numberSeparator: { separator: ' ' }
    });
  }

  public toggleOpenPlatform(product: Product): void {
    product[this.openName()] = !product[this.openName()];
  }

  public isAnyTeamInProduct(product: Product): boolean {
    return !!product.teams.length;
  }

  public updateValue(updateValueParams: UpdateValueParams): void {
    this.planFactService.updateValue(updateValueParams, this.selectedYear());
  }
}
